import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import ImageMob1x from './image-mob1x.png'
import ImageMob2x from './image-mob2x.png'
import ImageDesk1x from './image-desk1x.png'
import ImageDesk2x from './image-desk2x.png'
import classes from './MappedByAI.module.scss'

export const MappedByAI = () => {
  return (
    <Block as={'section'} className={classes.section}>
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        Mapped and updated by Al with human validation
      </Heading>
      <div className={classes.text_wrap}>
        <Text size={'lg'} center balance className={classes.text}>
          Maintaining the most extensive connector framework across the largest
          connector library on the market is only possible with the help of our
          Al-powered tooling such as Connector Builder.
        </Text>
        <Text size={'lg'} center balance className={classes.text}>
          We do not leave Al unchecked and our process involves manual
          validation of connectors to avoid hallucinations and mistakes.
        </Text>
        <Text size={'lg'} center balance className={classes.text}>
          They help us extract thousands of mappings from API documentation and
          specifications fast, normalize them to a common schema, and make
          available to you.
        </Text>
      </div>
      <div className={classes.visual}>
        <Picture
          className={classes.image}
          mobSrc1x={ImageMob1x.src}
          mobSrc2x={ImageMob2x.src}
          deskSrc1x={ImageDesk1x.src}
          deskSrc2x={ImageDesk2x.src}
          alt='Mapped and updated by Al'
          width={350}
          height={593}
          lazyLoad
        />
      </div>
    </Block>
  )
}
